import * as React from 'react';
import classNames from 'classnames';

import './styles.scss';

import Button, { IButtonProps } from '../Button';
import Buttons from '../Buttons';
import ButtonIcon, { IButtonIconProps } from '../ButtonIcon';
import Icon, { IconsAvailable } from '../Icon';

export interface IHeadingWithButtonsProps {
    /** Heading to display */
    title: React.ReactNode;
    /** Icon for heading */
    icon?: IconsAvailable;
    /** Description text */
    description?: React.ReactNode;
    /** Heading level */
    level?: 1 | 2 | 3 | 4 | 5 | 6;
    /** Buttons to display */
    buttons?: IButtonProps[];
    /** ButtonIcon list to display */
    buttonIcons?: IButtonIconProps[];
    /** Element to display */
    addOn?: React.ReactNode;
    /** className to append */
    className?: string;
}

interface IState {
}

/**
 * Renders heading with buttons.
 */
export default class HeadingWithButtons extends React.Component<IHeadingWithButtonsProps, IState> {
    static displayName: string = 'HeadingWithButtons';

    render () {
        let Elem: any = 'h2';
        if (this.props.level === 1) {
            Elem = 'h1';
        }
        if (this.props.level === 2) {
            Elem = 'h2';
        }
        if (this.props.level === 3) {
            Elem = 'h3';
        }
        if (this.props.level === 4) {
            Elem = 'h4';
        }
        if (this.props.level === 5) {
            Elem = 'h5';
        }

        return (
            <div className={classNames('heading-with-buttons', {
                'level-1': this.props.level === 1,
                'level-2': this.props.level === 2 || !this.props.level,
                'level-3': this.props.level === 3,
                'level-4': this.props.level === 4,
                'level-5': this.props.level === 5,
            }, this.props.className)}>
                <div className="heading-with-buttons-heading">
                    <div className="heading-with-buttons-heading-inner">
                        <Elem className="heading">
                            {this.props.icon && (
                                <Icon width={16} height={16} kind={this.props.icon}/>
                            )}
                            <span className="text">{this.props.title}</span>
                        </Elem>
                        {!!this.props.description && (
                            <div className="description">{this.props.description}</div>
                        )}
                    </div>
                    {this.props.buttonIcons && !!this.props.buttonIcons.length && (
                        <div className="heading-with-buttons-heading-icons">
                            {this.props.buttonIcons.map((b, i) => (
                                <ButtonIcon
                                    key={i}
                                    {...b}
                                    size={this.props.level && this.props.level > 2 ? 'small' : undefined}
                                />
                            ))}
                        </div>
                    )}
                </div>
                {this.props.addOn}
                {this.props.buttons && !!this.props.buttons.length && (
                    <Buttons>
                        {this.props.buttons.map((b, i) => (
                            <Button
                                key={i}
                                {...b}
                                size={this.props.level && this.props.level > 2 ? 'small' : undefined}
                            />
                        ))}
                    </Buttons>
                )}
            </div>
        );
    }
}
